import { AggregateLoaderType } from '@terragotech/form-renderer';
import { V2PageComponentDef } from '@terragotech/page-renderer';
import { camelCaseToSpaceSeparated } from '../../../../../components/FormElements';

export const createPageItem = (type: string, name: string, primaryColorPalette: string = ''): V2PageComponentDef => {
    const defaultTextInput = {
    label: name,
    oneLine: false,
    repeats: false,
  };
  const defaultMedia = {
    label: name,
    repeats: false,
  };
  const defaultChart = {
    label: name,
    repeats: false,
    chartType: 'bar' as const,
    chartOptions:{colorPalette: primaryColorPalette}
  };
  switch (type) {
    case 'text':
      return {
        type: 'text' as const,
        ...defaultTextInput,
      };
    case 'number':
      return {
        type: 'number' as const,
        ...defaultTextInput,
      };
    case 'date':
      return {
        type: 'date' as const,
        ...defaultTextInput,
      };
    case 'time':
      return {
        type: 'time' as const,
        ...defaultTextInput,
      };
    case 'datetime':
      return {
        type: 'datetime' as const,
        ...defaultTextInput,
      };
    case 'link':
      return {
        type: 'link' as const,
        ...defaultTextInput,
      };
    case 'image':
      return {
        type: 'image' as const,
        ...defaultMedia,
      };
    case 'file':
      return {
        type: 'file' as const,
        ...defaultMedia,
      };
    case 'chart':
      return {
        type: 'chart' as const,
        ...defaultChart,
      };
    case 'aggregateMap':
      return {
        type: 'aggregateMap' as const,
        label: name,
        aggregates: [
          {
            type: AggregateLoaderType,
            aggregateType: '',
          },
        ],
        height: undefined,
        includeWMS: undefined,
        latSplit: undefined,
        lonSplit: undefined,
        limitPerSection: undefined,
        symbols: undefined,
        showLocationSearch: undefined,
      };
    case 'streetView':
      return {
        type: 'streetView' as const,
        label: name,
        height: undefined,
      };
    case 'group':
      return {
        type: 'group' as const,
        label: name,
        repeats: false,
        template: {
          rows: 1,
          columns: 1,
          allowDynamicSizing: true,
          elements: {},
        },
      };
    case 'list':
      return {
        type: 'list' as const,
        label: name,
        columns: [],
        computedMap: undefined,
      };
    default:
      return {
        type: 'text' as const,
        ...defaultTextInput,
      };
  }
};

export const generatePageItemName = (type: string, pageItemsList: string[]): string => {
  let counter = 1;

  const getFreeName = (): string => {
    const name = `${camelCaseToSpaceSeparated(type)}${counter}`;
    if (pageItemsList.includes(name)) {
      counter += 1;
      return getFreeName();
    }
    return name;
  };

  return getFreeName();
};
